import script from "./VirtualButtonUpdatePage.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualButtonUpdatePage.vue?vue&type=script&setup=true&lang=js"

import "./VirtualButtonUpdatePage.vue?vue&type=style&index=0&id=502d23b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-502d23b2"]])

export default __exports__